exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_1pdf4jTb{height:280px}", ""]);

// exports
exports.locals = {
	"container": "container_1pdf4jTb"
};